import Vue from 'vue';
import { formatNumberForDisplay } from '@/helpers/NumberFormatter';

Vue.filter('moneyFormat', (rawPrice: number | null | undefined) => {
    return formatNumberForDisplay(rawPrice, 2, 2);
});
